<template>
  <div class="container">
    <div class="field is-horizontal">
      <div class="field-body">
        <div class="field is-narrow">
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="cmbGrupoIndicador">
                <option value="0">Todos os grupos de indicadores</option>
                <option v-for="gi in gruposIndicadores" :key="gi.id" :value="gi.id">
                  {{ gi.descricao }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="field">
          <button type="submit" class="button is-primary" @click.stop.prevent="filterRecords">Filtrar</button>
        </div>
        <div class="field">
          <button class="button is-primary is-pulled-right" @click="add" :disabled="!mostraValoresReferencia">
            <span class="icon">
              <i class="fas fa-plus"></i>
            </span>
            <span>Cadastrar</span>
          </button>
        </div>
      </div>
    </div>
    <hr>

    <div class="modal" :class="{ 'is-active': isShowModal }">
      <div class="modal-background" v-on:click="isShowModal = false"></div>
      <div class="modal-card">
        <header class="modal-card-head has-background-primary">
          <p class="modal-card-title has-text-white">Cadastrar</p>
          <button class="delete" aria-label="close" v-on:click="isShowModal = false"></button>
        </header>
        <section class="modal-card-body">
          <form>
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Status</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="valorReferenciaIndicador.status">
                      <option value="1">Péssimo</option>
                      <option value="2">Ruim</option>
                      <option value="3">Normal</option>
                      <option value="4">Bom</option>
                      <option value="5">Excelente</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Faixa Inicial</label>
              </div>
              <div class="field-body">
                <div class="field is-narrow">
                  <input class="input" type="number" placeholder="Informe a faixa inicial" v-model="valorReferenciaIndicador.faixa_inicial">
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Faixa Final</label>
              </div>
              <div class="field-body">
                <div class="field is-narrow">
                  <input class="input" type="number" placeholder="Informe a faixa final" v-model="valorReferenciaIndicador.faixa_final">
                </div>
              </div>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="save">Salvar</button>
          <button class="button" v-on:click="isShowModal = false">Cancelar</button>
        </footer>
      </div>
    </div>

    <div class="columns" v-show="showInfo">
      <div class="column is-5">
        <div class="card">
          <header class="card-header has-background-primary">
            <p class="card-header-title has-text-white">Valores de Referência do Indicador</p>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Grupo</th>
                    <th>Indicador</th>
                    <th class="has-text-centered">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="i in indicadores" :key="i.id">
                    <td>{{ i.grupo_indicador.descricao }}</td>
                    <td>{{ i.descricao }}</td>
                    <td class="has-text-centered">
                      <button class="button is-small is-success is-outlined" @click="callValRef(i)" :disabled="mostraValoresReferencia" title="Configurar Valores de Referência">
                        <span class="icon is-small">
                          <i class="fas fa-th-list"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="column" v-show="mostraValoresReferencia">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">Valores de Referência do Indicador {{ indicadorSelecionado.descricao }}</p>
            <a class="card-header-icon" @click="mostraValoresReferencia = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Faixa Inicial</th>
                    <th>Faixa Final</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vri, index) in valoresReferenciasIndicadores" :key="vri.id">
                    <td :class="statusClasses[vri.status]">{{ statusLabels[vri.status] }}</td>
                    <td>{{ vri.faixa_inicial }}</td>
                    <td>{{ vri.faixa_final }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraValoresReferencia = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {http} from '../../services/config'

    export default {
        name: "ValorReferenciaIndicador",

        data(){
            return{
                valorReferenciaIndicador: {
                    id: null,
                    faixa_inicial: null,
                    faixa_final: null,
                    status: null,
                    index: null
                },
                statusClasses: {
                  '1': 'has-background-danger-dark has-text-white-bis',
                  '2': 'has-background-danger-light',
                  '3': 'has-background-warning-light',
                  '4': 'has-background-success-light',
                  '5': 'has-background-success-dark has-text-white-bis'
                },
                statusLabels: {
                  '1': 'Péssimo',
                  '2': 'Ruim',
                  '3': 'Normal',
                  '4': 'Bom',
                  '5': 'Excelente'
                },
                gruposIndicadores: [],
                indicadores: [],
                valoresReferenciasIndicadores: [],
                indicadorSelecionado: [],
                cmbGrupoIndicador: 0,
                showInfo: false,
                mostraValoresReferencia: false,
                isShowModal: false
            }
        },

        methods: {
            add: function() {
                this.clearFields()
                this.isShowModal = true              
            },

            edit: function(index){
                this.valorReferenciaIndicador.id = this.valoresReferenciasIndicadores[index].id
                this.valorReferenciaIndicador.indicador = this.indicadorSelecionado.id
                this.valorReferenciaIndicador.status = this.valoresReferenciasIndicadores[index].status
                this.valorReferenciaIndicador.faixa_inicial = this.valoresReferenciasIndicadores[index].faixa_inicial
                this.valorReferenciaIndicador.faixa_final = this.valoresReferenciasIndicadores[index].faixa_final
                this.valorReferenciaIndicador.index = index
                this.isShowModal = true              
            },

            erase: function(index){
                if (window.confirm('Confirma exclusão?')) {
                    http.delete('/valorReferenciaIndicador/excluir/'+this.valoresReferenciasIndicadores[index].id).then(response =>{
                        this.valoresReferenciasIndicadores.splice(index, 1)
                        if (response.status == 204) {
                            alert('Registro excluído!')
                        }
                    }).catch(e => {
                        console.log(e);
                    })
                }
            },


            save: function(){
                var data

                if (this.valorReferenciaIndicador.status == null) {
                    alert('Status não selecionado!')
                    return
                }

                if (this.valorReferenciaIndicador.faixa_inicial == null || this.valorReferenciaIndicador.faixa_inicial == '' ) {
                    alert('Faixa inicial não informada!')
                    return
                }

                if (this.valorReferenciaIndicador.faixa_final == null || this.valorReferenciaIndicador.faixa_final == '' ) {
                    alert('Faixa final não informada!')
                    return
                }

                data = {id: this.valorReferenciaIndicador.id,
                    indicador: this.indicadorSelecionado.id,
                    status: this.valorReferenciaIndicador.status,
                    faixa_inicial: this.valorReferenciaIndicador.faixa_inicial,
                    faixa_final: this.valorReferenciaIndicador.faixa_final
                }

                if (this.valorReferenciaIndicador.id == null) {
                    http.post('/valorReferenciaIndicador/adicionar', data).then(response =>{
                        if (response.data.id != undefined && response.data.id != '') {
                            this.valorReferenciaIndicador.id = response.data.id
                            this.valoresReferenciasIndicadores.push(this.valorReferenciaIndicador)
                            this.clearFields()
                        } else {
                            alert(response.request.responseText)
                        }
                    }).catch(e => {
                        alert(e.response.data);
                        return
                    })
                } 
                else {
                    http.put('/valorReferenciaIndicador/editar/'+this.valorReferenciaIndicador.id, data).then(response =>{
                        this.valoresReferenciasIndicadores[this.valorReferenciaIndicador.index].status = response.data.status
                        this.valoresReferenciasIndicadores[this.valorReferenciaIndicador.index].faixa_inicial = response.data.faixa_inicial
                        this.valoresReferenciasIndicadores[this.valorReferenciaIndicador.index].faixa_final = response.data.faixa_final
                        this.valoresReferenciasIndicadores[this.valorReferenciaIndicador.index].indicador = this.indicadorSelecionado
                    }).catch(e => {
                        alert(e.response.data);
                        return
                    })
                }                    

            },

            clearFields: function() {
                this.valorReferenciaIndicador = {
                    id: null,
                    faixa_inicial: null,
                    faixa_final: null,
                    status: null,
                    index: null
                }
            },

            filterRecords: function(){
                http.get('indicador/listar/', {params: {
                    idGrupoIndicador: this.cmbGrupoIndicador
                }}).then(response => {
                    this.indicadores = response.data.results
                    if (this.indicadores.length == 0) {
                        this.showInfo = false
                        alert('Não há indicadores associados aos parâmetros selecionados!')
                    } else {
                        this.showInfo = true
                    }
                })
            },

            callValRef: function(ind) {
                this.mostraValoresReferencia = true
                this.indicadorSelecionado = ind
                http.get('valorReferenciaIndicador/listar/', {params: {
                    idIndicador: this.indicadorSelecionado.id,
                }}).then(response => {
                    this.valoresReferenciasIndicadores = response.data.results
                })
            }

        },

        mounted: function() {
        },
        
        created: function() {
            http.get('grupoIndicador/listar/').then(response => {
                this.gruposIndicadores = response.data.results
            })

        }

    }
</script>

<style scoped>
</style>